import { onFind } from "@elements/init-modules-in-scope";
import { findAllIn } from "@elements/dom-utils";

export function init() {
    onFind('.footer__main', (footer) => {
        const row = footer.querySelector('.row');
        if (!row) return;

        const originalColumns = Array.from(row.children);

        const setFooterTabOrder = () => {
            const isDesktop = window.matchMedia('(min-width: 768px)').matches;
            
            if (isDesktop) {
                const columns = Array.from(row.children);
                columns.sort((a, b) => {
                    const orderA = parseInt(Array.from(a.classList).find(c => c.startsWith('order-md-'))?.split('-').pop() || 0);
                    const orderB = parseInt(Array.from(b.classList).find(c => c.startsWith('order-md-'))?.split('-').pop() || 0);
                    return orderA - orderB;
                });

                columns.forEach(col => row.appendChild(col));
            } else {
                originalColumns.forEach(col => row.appendChild(col));
            }
        };

        window.addEventListener('resize', setFooterTabOrder);
        setFooterTabOrder();
    });
}
